import * as React from "react";

import {PrinterStore} from "../App";


import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";

import {PrinterSelection} from "./PrinterSelection";
import {SwitchContainer} from "shared/controls/animation/SwitchContainer";
import {RNTextInput} from "shared/controls/SingleInputs/RNTextInput";


library.add(faSpinner);

export class PrinterTab extends React.Component<PrinterTabProps, PrinterTabState> {
    static defaultProps: Partial<PrinterTabProps> = {};

    constructor(props: PrinterTabProps) {
        super(props);
        let state:PrinterTabState={
            status:"Authenticate",
            isAuthenticated:rednaoSettingsParams.PrinterToken!=null&&rednaoSettingsParams.PrinterToken.refreshtoken!='',
            loadingPrinters:false,
            printers:[]
        };
        state.status=this.GetStatus(state);
        this.state =state;
        console.log(this.props.store);

    }




    public render() {
        return (
            <React.Fragment>
                <SwitchContainer>
                    {
                        this.state.status!="Done"&&
                        <div style={{backgroundColor: '#efefef',padding: 10, border: '1px solid #bfbfbf', marginBottom: 10}}>
                            <p><strong style={{color: 'red'}}>Configuration Instructions</strong></p>
                            <p>To print the pdfs your printer should be connected to 'Google Cloud Printing' (its
                                free!), <a target={'_blank'}
                                           href='http://wooinvoice.rednao.com/knowledge-base/getting-started/'>learn
                                    how to connect your printer to Google Cloud Reader here.</a></p>
                            <p>To successfully connect your printer to your site you will need this information (how to use it is explained in the tutorial above):</p>
                            <div className={'rncontrol'}>
                                <label>Authorized javascript origin that you should use</label>
                                <input type={'text'} value={this.GetDomain(rednaoSettingsParams.Validation2URL)} readOnly/>
                            </div>
                            <div className={'rncontrol'}>
                                <label>Authorized redirect uri that you should use</label>
                                <input type={'text'} value={rednaoSettingsParams.Validation2URL} readOnly/>
                            </div>
                        </div>
                    }
                </SwitchContainer>
                <RNTextInput<PrinterStore> Label={"Google Client ID"} Store={this.props.store} PropertyName={"clientid"} onChange={e=>this.UpdateStatus()}/>
                <RNTextInput<PrinterStore> Label={"Google Client Secret"} Store={this.props.store} PropertyName={"clientsecret"} onChange={e=>this.UpdateStatus()}/>
                <SwitchContainer>
                    {this.state.status == 'Authenticate' &&
                        <div className={'rncontrol'}>
                            <button onClick={e=>this.Authenticate()} className={'rnbtn rnbtn-primary'}>Click here to authenticate and link your printer with
                                your site
                            </button>
                        </div>
                    }
                </SwitchContainer>
                <SwitchContainer>
                    {this.state.status == 'Done' &&
                        <div>
                            <PrinterSelection<PrinterStore> defaultValue={{label:rednaoSettingsParams.DefaultPrinterLabel,value:rednaoSettingsParams.DefaultPrinter}} disabled={this.state.loadingPrinters} Label='Default Printer' Store={this.props.store} PropertyName={'DefaultPrinter'} onChange={(e)=>this.props.store.SetValue('DefaultPrinterLabel',e.label)}/>
                            <a target={'_blank'} href={'https://www.google.com/cloudprint/#printers'}>Your Printers</a>
                        </div>

                    }
                </SwitchContainer>

            </React.Fragment>

        )
    }

    private GetStatus(state:PrinterTabState=null):status {
        if(state==null)
            state=this.state;
        if(this.props.store.clientsecret==''||this.props.store.clientid=='')
            return "SubmitCredentials";

        if(!state.isAuthenticated)
            return "Authenticate";

        return 'Done';

    }

    private UpdateStatus(){
        let status=this.GetStatus();
        switch(status)
        {
            case "Authenticate":
            case "SubmitCredentials":
                this.setState({printers:[],isAuthenticated:false});
        }
        this.setState({status:status});
    }

    private Authenticate() {
        let w=600;
        let h=450;
        let url=ajaxurl+`?action=rednao_validate_google_auth_token1&client_id=${this.props.store.clientid}&client_secret=${encodeURIComponent(this.props.store.clientsecret)}`;
        let dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        let dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

        let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

        let left = ((width / 2) - (w / 2)) + dualScreenLeft;
        let top = ((height / 2) - (h / 2)) + dualScreenTop;
        let newWindow = window.open(url, 'Google authentication', 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

        // Puts focus on the newWindow
        if (window.focus) {
            newWindow.focus();
        }


        var pollTimer   =   window.setInterval(()=> {
            try {
                if (newWindow.document.URL.indexOf('rednao_validate_google_auth_token3') != -1) {
                    window.clearInterval(pollTimer);
                    this.setState({status:'Done'});
                }
            } catch(e) {
            }
        }, 100);

    }

    private GetDomain(Validation2URL: string) {
        return Validation2URL.match(/https?:\/\/[^\/]*/)[0];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface PrinterTabProps {
    store:PrinterStore;
}

type status='SubmitCredentials'|'Authenticate'|'Done';
interface PrinterTabState {
    status:status;
    isAuthenticated:boolean;
    loadingPrinters:boolean;
    printers:PrinterItem[];

}

interface PrinterItem{
    id:string;
    name:string;
}


declare let ajaxurl;
//#endregion "My Region"